/**
 * The Nakama client, and where it points.
 *
 * Its own module so `auth.ts` and `session.ts` can both use it without
 * importing each other — the cycle that would otherwise form is the kind that
 * compiles, bundles with only a warning, and then fails at runtime with
 * "cannot access before initialization".
 */

import { Client } from '@heroiclabs/nakama-js';

const HOST = (import.meta.env['VITE_NAKAMA_HOST'] as string | undefined) ?? window.location.hostname;
const PORT = (import.meta.env['VITE_NAKAMA_PORT'] as string | undefined) ?? '7350';
const SERVER_KEY = (import.meta.env['VITE_NAKAMA_KEY'] as string | undefined) ?? 'defaultkey';
const USE_SSL = (import.meta.env['VITE_NAKAMA_SSL'] as string | undefined) === 'true';

export const client = new Client(SERVER_KEY, HOST, PORT, USE_SSL);

/**
 * Whether to speak TLS - and it has to be passed to `createSocket` too.
 *
 * The SDK takes `useSSL` twice: once here, which governs the HTTP API, and
 * again per socket, which governs the WebSocket scheme. They do not share a
 * value, so a socket opened with the default `false` connects over `ws://`
 * however this client was built. On an HTTPS page the browser then blocks it
 * as mixed content and the game never receives a match update - with the REST
 * calls still working, which makes it look like a server problem.
 */
export const useSSL = USE_SSL;

/** For the few calls that cannot go through the SDK, like password reset. */
export const httpBase = `${USE_SSL ? 'https' : 'http'}://${HOST}:${PORT}`;
export const httpKey = SERVER_KEY;
